import { appConfig } from '../../config/appConfig';

// Full-screen permission error — PERMISSION_ERROR state.
// Shown when a required permission was denied. No retry button; the user
// must enable permissions in browser settings and reload.

export function renderPermissionErrorScreen(root: HTMLElement): void {
  root.innerHTML = `
    <div class="error-screen">
      <div class="error-screen__content">
        <p class="error-screen__message">${appConfig.copy.permissionError}</p>
      </div>
    </div>
  `;
}
